import { handleResponse, handleError } from "./apiUtils";
import { BASE_URL } from "../utils/connectApi";

export function getRecipes() {
  return fetch(BASE_URL + "recipe/")
    .then(handleResponse)
    .catch(handleError);
}

export function getRecipesByKeyword(keyword) {
  return fetch(BASE_URL + `recipe/keyword/${keyword}`)
    .then(handleResponse)
    .catch(handleError);
}

export function getRecipeById({ id }) {
  return fetch(BASE_URL + `recipe/${id}`)
    .then(handleResponse)
    .catch(handleError);
}

export function saveRecipe({ recipe }) {
  const token = sessionStorage.getItem("cb_token");
  return fetch(BASE_URL + "recipe/" + (recipe._id || ""), {
    method: recipe._id ? "PUT" : "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(recipe),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteRecipe({ recipe }) {
  const token = sessionStorage.getItem("cb_token");
  return fetch(BASE_URL + `recipe/${recipe._id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteRecipeIngredient(recipe, ingredient) {
  const token = sessionStorage.getItem("cb_token");
  return fetch(BASE_URL + `recipe/ingredientList`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ recipe, ingredient }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteRecipeStep(recipe, step) {
  const token = sessionStorage.getItem("cb_token");
  return fetch(BASE_URL + `recipe/step`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ recipe, step }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function updateRecipeAdmin({ recipeId, userId, userEmail }) {
  const token = sessionStorage.getItem("cb_token");

  return fetch(BASE_URL + `recipe/admin`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ recipeId, userId, userEmail }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUserRecipes() {
  const token = sessionStorage.getItem("cb_token");
  return fetch(BASE_URL + `recipe/user`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}
